/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 메인페이지의 학교 상세 정보
 * 버전 : 1.0
 * 파일명 : RecruitmentPage.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================
 * 수정 : 2025-01-09, 강동형 : 탭 분리
 *================================================================*/

import { useEffect, useState } from 'react'
import RecruitCalendar from 'src/components/recruitment/RecruitCalendar';
import RecruitSelectYear from 'src/components/recruitment/RecruitSelectYear';
import RecruitSelectMonth from 'src/components/recruitment/RecruitSelectMonth';
import RecruitSelectType from 'src/components/recruitment/RecruitSelectType';
import RecruitSelectStatus from 'src/components/recruitment/RecruitSelectStatus';
import { NextButton } from 'src/components/common/CommonStyled';
import RecruitDialog from 'src/components/recruitment/RecruitDialog';
import { useRecruitStore } from 'src/stores/RecruitStore';
import styled from "styled-components";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
`;

const DateSelectBoxWarpper = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  padding-bottom: 16px;
`;

const StatusSelectBoxWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 16px;
`;

const StatusSelectContainer = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
  margin-right: auto;
`;

const TabList = styled.div`
  display: flex;
  width: 100%;
`;

const TabButton = styled.div<{ $selected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: bold;
  color: ${({ $selected }) => ($selected ? "black" : "#7F7F89")};
  border-bottom: 2px solid ${({ $selected }) => ($selected ? "black" : "transparent")};
  padding: 15px 0px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
`;

const BarWrapper = styled.div`
  background-color: #fff;
  border-bottom: 1px solid #DDD;
  margin: 0px -20px;
`

const SrcollBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding :16px 20px 20px;
`

const RecruitmentPage = () => {
  const today = new Date()
  const reset = useRecruitStore((state)=>state.reset)
  const setField = useRecruitStore((state)=>state.setField)
  const dialogState = useRecruitStore((state)=>state.dialogState)
  const [tab,setTab] = useState<'모집 일정' | '축제 정보'>('모집 일정')
  useEffect(()=>{
    if(dialogState !== '축제 등록'){
      setTab(dialogState)
    }
    return (()=>{
      reset()
    })
  },[])

  useEffect(()=>{
    setField('dialogState',tab)
  },[tab])

  const setToday = ()=>{
    setField('year', today.getFullYear())
    setField('month',today.getMonth()+1)
  }

  return (
    <PageWrapper>
      <BarWrapper>
        <TabList>
          <TabButton $selected={tab === '모집 일정'} onClick={() => setTab('모집 일정')} style={{marginLeft:'20px'}}>
          모집 일정
          </TabButton>
          <TabButton $selected={tab === '축제 정보'} onClick={() => setTab('축제 정보')} style={{marginRight:'20px'}}>
          축제 정보
          </TabButton>
        </TabList>
      </BarWrapper>
      <SrcollBody>
        {tab === '모집 일정' &&
        <>
          <DateSelectBoxWarpper>
            <RecruitSelectYear/>
            <RecruitSelectMonth/>
          </DateSelectBoxWarpper>
          <StatusSelectBoxWrapper>
            <StatusSelectContainer>
              <RecruitSelectType whichTab={tab}/>
              <RecruitSelectStatus whichTab={tab}/>
            </StatusSelectContainer>
            <NextButton style={{marginLeft:'auto', height:'46px' , width:'80px'}} onClick={setToday}>오늘</NextButton>
          </StatusSelectBoxWrapper>
          <RecruitCalendar whichTab={tab}/>
        </>
        }
        {tab === '축제 정보' &&
          <>
            <DateSelectBoxWarpper>
              <RecruitSelectYear/>
              <RecruitSelectMonth/>
            </DateSelectBoxWarpper>
            <StatusSelectBoxWrapper>
              <StatusSelectContainer>
                <RecruitSelectType whichTab={tab}/>
                <RecruitSelectStatus whichTab={tab}/>
              </StatusSelectContainer>
              <NextButton style={{marginLeft:'auto', height:'46px' , width:'80px'}} onClick={setToday}>오늘</NextButton>
            </StatusSelectBoxWrapper>
            <RecruitCalendar whichTab={tab}/>
          </>
        }
        <RecruitDialog tab={tab}/>
      </SrcollBody>
    </PageWrapper>
  )
}

export default RecruitmentPage